import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { SxProps, useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { ReactNode } from "react";

type DigitButtonProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  sx?: SxProps;
  onClick?: () => void;
};
export default function DigitButton({
  title,
  subtitle,
  sx,
  onClick,
}: DigitButtonProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        boxShadow: theme.shadows[3],
        px: 1,
        py: 0.5,
        borderRadius: "16px",
        background: "hsla(272, 17%, 34%, 0.85)",
        boxSizing: "border-box",
        width: "45px",
        height: "40px",
        cursor: "pointer",
        "&:hover": {
          background: "hsla(271, 18%, 27%, 0.85)",
        },
        ...sx,
      }}
      onClick={onClick}
    >
      <Stack
        width="100%"
        height="100%"
        sx={{
          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "16px",
            lineHeight: subtitle ? 1.2 : undefined,
          }}
        >
          {title}
        </Typography>
        {Boolean(subtitle) && (
          <Typography
            sx={{
              fontSize: "10px",
              textTransform: "uppercase",
              lineHeight: 1.1,
              opacity: 0.7,
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Stack>
    </Box>
  );
}
